import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  employees:[],
  employeesLength: 0,
}

export default function employeesHierarchyReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_IMMEDIATE_BOSS:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADING_IMMEDIATE_BOSS:
      return {...state, saveLoading: action.payload}
    case actions.GET_IMMEDIATE_BOSS:
      return {...state, employees: action.payload.employees, employeesLength: action.payload.employeesLength}
    default:
      return state
  }
}